import { ArrowLeft } from "lucide-react";
import { ShowBase } from "ra-core";
import { Link, useParams } from "react-router";
import { DealShowContent } from "./DealShow";

/**
 * DealShowPage — versión standalone (page-level) del detalle de una
 * oportunidad. Se registra como `show` en el resource `deals` para que
 * `/deals/:id/show` funcione como ruta normal, accesible desde links
 * en otras vistas (juntas, contactos, etc.).
 *
 * El Kanban (`DealList`) sigue funcionando por su lógica interna de
 * matchPath, pero ahora navegar directo a la URL desde cualquier otro
 * lugar también muestra la oportunidad correctamente.
 */
export function DealShowPage() {
  const { id } = useParams();
  if (!id) return null;
  return (
    <div className="px-7 pt-6 pb-7">
      <div className="flex items-center gap-3 mb-5 flex-wrap">
        <Link to="/deals" className="musco-btn musco-btn-g">
          <ArrowLeft size={14} /> Oportunidades
        </Link>
        <h1 className="m-0 text-[28px] font-bold tracking-[-0.025em]">
          Detalle de oportunidad
        </h1>
      </div>
      <div className="musco-hero" style={{ maxWidth: 1100, marginInline: "auto" }}>
        <ShowBase resource="deals" id={id}>
          <DealShowContent />
        </ShowBase>
      </div>
    </div>
  );
}
